var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeftThick24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33 12c0-.434.187-.806.497-1.053l6.94-6.074c.497-.434 1.178-.372 1.612.124.372.496.372 1.177-.124 1.55l-6.073 5.33c-.062.061-.062.123 0 .185l6.073 5.33c.496.434.558 1.116.124 1.611-.434.496-1.115.558-1.611.124l-.062-.062-6.88-6.011c-.31-.248-.495-.682-.495-1.054z"
  })));
}
export default SvgIconLeftThick24;